import { Checkbox, FormControlLabel, TextField } from '@mui/material';

export default function CredentialField({ field, form }) {
  const { name, label, type, secret, hint } = field;
  if (type === 'checkbox') return <FormControlLabel label={label} control={<Checkbox checked={Boolean(form.values[name])} disabled={form.disabled} onChange={(event) => form.change(name, event.target.checked)} />} />;
  return <>
    <TextField fullWidth size="small" name={name} label={label} type={secret ? 'password' : type || 'text'}
      value={form.values[name] ?? ''} disabled={form.disabled || Boolean(form.clear[name])}
      autoComplete={secret ? 'new-password' : 'off'}
      onChange={(event) => form.change(name, type === 'number' && event.target.value !== '' ? Number(event.target.value) : event.target.value)}
      helperText={hint || (secret ? 'Leave blank to keep the saved value.' : undefined)} />
    {secret && <FormControlLabel label={`Clear saved ${label.toLowerCase()}`} control={<Checkbox checked={Boolean(form.clear[name])} disabled={form.disabled} onChange={(event) => form.clearSecret(name, event.target.checked)} />} />}
  </>;
}
